import React from "react";
import { SERVICES, SPA_SERVICES, IMAGES } from "../data/site";
import { Seo } from "../components/Seo";
import { SpaServicesSection } from "../components/SpaServicesSection";

export const AestheticServicesPage = () => {
  const aestheticService = SERVICES.find((s) => s.slug === "aesthetic-dentistry");
  const heroImage =
    (Array.isArray(aestheticService?.banner) ? aestheticService?.banner.find(Boolean) : aestheticService?.banner) ||
    (Array.isArray(aestheticService?.image) ? aestheticService?.image.find(Boolean) : aestheticService?.image) ||
    IMAGES.clinicInterior1;
  const bannerFocusRaw = aestheticService?.bannerfocus || aestheticService?.bannerFocus || "center";
  const bannerFocusClass =
    bannerFocusRaw === "top" ? "object-top" :
    bannerFocusRaw === "bottom" ? "object-bottom" :
    "object-center";

  return (
    <div data-testid="aesthetic-services-page">
      <Seo
        title="Aesthetic Services | Smiles by Dr. K"
        description="Minimally invasive aesthetic services including Botox and Juvederm fillers, delivered with precision and care."
      />
      <section className="relative h-[40vh] overflow-hidden bg-bone">
        <img
          src={heroImage}
          alt={aestheticService?.name || "Aesthetic Services"}
          className={`absolute inset-0 w-full h-full object-cover ${bannerFocusClass} transition-opacity duration-[1500ms] ease-in-out`}
        />
      </section>
      <SpaServicesSection services={SPA_SERVICES} />
    </div>
  );
};
